import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RecommendedProductCard from 'components/common/recommended_product_card';
import { Currency } from '../../rpc/model/squareup/connect/v2/common/money';
import { updateItem } from 'utilities/cart';

const RecommendedProducts = (props) => {
  const {
    products,
    orderRefresh,
    setRecommendedProductsData,
    setToast,
    trackViewEvent,
    trackClickEvent,
    trackingEventTypes,
  } = props;
  const { t } = useTranslation();
  const [requesting, setRequesting] = useState(false);
  const [activeItemId, setActiveItemId] = useState(null);

  // As a product requirement, we should only show up to 4 recommendations at a time.
  const maxProducts = products.slice(0, 4);

  const removeRecommendedProduct = (masterVariantId) => {
    const updatedProducts = products.filter((product) => {
      const { masterVariantId: productMasterVariantId } = product;
      return productMasterVariantId !== masterVariantId;
    });

    setRecommendedProductsData(updatedProducts);
  };

  const onSuccess = ({ slug, name, masterVariantId }) => {
    setRequesting(false);
    trackClickEvent({
      eventName: trackingEventTypes.AddToCart,
      slug,
      name,
      id: masterVariantId,
      eventDescription: 'Add product recommendation to cart',
      actionItem: 'add_to_cart',
      subActionItem: name,
    });
    orderRefresh().then(removeRecommendedProduct(masterVariantId));
  };

  const onFailure = (name) => {
    setRequesting(false);
    setToast({
      timeout: 3000,
      open: true,
      message: t('productPage.addToCartError', { name }),
      variant: 'critical',
    });
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      spacing={3}
      pl={1}
      sx={{ mt: 1 }}
    >
      {maxProducts.map((product, index) => {
        const {
          masterVariantId,
          slug,
          displayData: { name, images },
          price: { amount, currency },
        } = product;

        if (
          !images[0]?.url ||
          !name ||
          !masterVariantId ||
          !slug ||
          !amount ||
          !currency
        ) {
          return null;
        }

        return (
          <RecommendedProductCard
            id={masterVariantId}
            key={`recommended_product_item_${index}`}
            slug={slug}
            title={name}
            img={images[0].url}
            price={amount}
            currency={Currency[currency]}
            requesting={requesting}
            activeItemId={activeItemId}
            trackViewEvent={trackViewEvent}
            trackingEventTypes={trackingEventTypes}
            onAddToCartClick={() => {
              setRequesting(true);
              setActiveItemId(masterVariantId);
              updateItem(
                masterVariantId, // variant_token,
                1, // quantity,
                [], // add-ons
                () => onSuccess({ slug, name, masterVariantId }),
                () => onFailure(name),
              );
            }}
          />
        );
      })}
    </Grid>
  );
};

export default RecommendedProducts;
